define.alias("shared/components/shared/ui/social-set-switcher", "media/components/shared/ui/social-set-switcher");